export default (language: string): void => {
  const formattedCode = language.toLowerCase();

  document.querySelector('html')!.setAttribute('lang', formattedCode.slice(0, 2));
};
